import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="mt-4 text-center pb-4">
      <div className="flex flex-wrap justify-center gap-4 mb-4">
        <Link
          to="/about"
          className="text-neutral-600 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-300"
        >
          {t("home.about")}
        </Link>
        <Link
          to="/downloads"
          className="text-neutral-600 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-300"
        >
          {t("home.downloads")}
        </Link>
        <Link
          to="/other-apps"
          className="text-neutral-600 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-300"
        >
          {t("home.otherApps")}
        </Link>
        <Link
          to="/privacy"
          className="text-neutral-600 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-300"
        >
          {t("home.privacy")}
        </Link>
        <Link
          to="/terms"
          className="text-neutral-600 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-300"
        >
          {t("home.terms")}
        </Link>
        <Link
          to="/faq"
          className="text-neutral-600 dark:text-neutral-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors duration-300"
        >
          {t("home.faq")}
        </Link>
      </div>
      <p className="text-sm text-neutral-500 dark:text-neutral-500">
        {t("home.footer")}
      </p>
    </div>
  );
};

export default Footer;
